import logo from './redIcon.png';
import './App.css';
import React from "react";

import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { collection, doc, getDoc, getDocs, setDoc } from "firebase/firestore";

import { useState } from 'react';
import { firestore, auth } from "./firebase";

function Discord() {
  return (
    <div className="App bg-gradient-to-br from-ddp to-darkp min-h-screen">
      <br/>
      <p className="text-3xl ml-20 mt-20 font-bold">Email successfully verified.</p>
      <button onClick={() => window.location.replace("/signin")} className="bg-darkg hover:bg-ddg transition duration-50 px-16 py-2 mt-5 rounded-lg text-lg font-bold">Sign In</button>
    </div>
  );
}
         
export default Discord;